const Health = () => (
  <p>Healhy</p>
)

export default Health;